var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "V Logos/White on red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login_Error2",
    transform: "translate(-149.000000, -375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(149.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-Brand-/-Logos-/-Roundel-/-red",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vod_Roundel_red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0002887,41 C82.0002887,63.643838 63.643838,82 41.0002887,82 C18.3564507,82 0,63.643838 0,41 C0,18.356162 18.3564507,0 41.0002887,0 C63.643838,0 82.0002887,18.356162 82.0002887,41",
    id: "Fill-1",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3251127,63.8624013 C30.0599296,63.8996261 18.3402528,54.2851549 18.288874,38.8469225 C18.2549035,28.6373451 23.7630514,18.8100493 30.8037042,12.9796761 C37.6712042,7.29309155 47.0795493,3.64380282 55.612169,3.61539653 C56.710507,3.61175352 57.8590845,3.70328169 58.5624366,3.94119718 C51.1018803,5.48851408 45.1640986,12.431662 45.1900845,20.3088592 C45.1909507,20.5692958 45.2146268,20.8473451 45.2403239,20.9769859 C57.7245352,24.0176268 63.3917746,31.5503662 63.4268184,41.9736056 C63.4610704,52.3962676 55.2324859,63.8160092 41.3251127,63.8624013",
    id: "Fill-2",
    fill: "#FFFFFF"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0c0ba9c4cd5868a46887f8bddc187c6.svg";
export { ForwardRef as ReactComponent };